import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'

export type ThemeMode = 'light' | 'dark'

type State = {
  mode: ThemeMode
}

type Actions = {
  setMode: (mode: ThemeMode) => void
  toggle: () => void
}

const detectInitialMode = (): ThemeMode => 'light'

const applyToDocument = (mode: ThemeMode) => {
  if (typeof document === 'undefined') return

  document.documentElement.setAttribute(
    'data-theme',
    mode === 'dark' ? 'dark' : 'mytheme',
  )
  document.documentElement.classList.toggle('dark', mode === 'dark')
}

export const useThemeModeStore = create<State & Actions>()(
  devtools(
    persist(
      zustandPlugin(
        (set) => ({
          mode: detectInitialMode(),
          setMode: (mode) => set({ mode }, false, 'setMode'),
          toggle: () =>
            set(
              (s) => ({ mode: s.mode === 'dark' ? 'light' : 'dark' }),
              false,
              'toggle',
            ),
        }),
        'theme-mode',
      ),
      {
        name: 'theme-mode',
        storage: createJSONStorage(() => localStorage),
        partialize: (s) => ({ mode: s.mode }),
      },
    ),
    { name: 'EasyTacho', store: 'theme-mode' },
  ),
)

if (typeof window !== 'undefined') {
  applyToDocument(useThemeModeStore.getState().mode)
  useThemeModeStore.subscribe((state, prev) => {
    if (state.mode !== prev.mode) applyToDocument(state.mode)
  })
}
